import { Record, Map } from 'immutable';

const UserPictureRecord = Record({
  originalHref: undefined,
  templateHref: undefined,
  _links: new Map(),
  _forms: new Map()
});

class UserPicture extends UserPictureRecord {

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default UserPicture;


// WEBPACK FOOTER //
// ./src/api/models/userPicture.js